export const GET_DEALS_LIST_REQUEST = "GET_DEALS_LIST_REQUEST";
export const GET_DEALS_LIST_REQUEST_SUCCESS = "GET_DEALS_LIST_REQUEST_SUCCESS";
export const GET_DEALS_LIST_REQUEST_ERROR = "GET_DEALS_LIST_REQUEST_ERROR";

export const ADMIN_DEAL_UPDATE_REQUEST = "ADMIN_DEAL_UPDATE_REQUEST";
export const ADMIN_DEAL_UPDATE_SUCCESS = "ADMIN_DEAL_UPDATE_SUCCESS";
export const ADMIN_DEAL_UPDATE_ERROR = "ADMIN_DEAL_UPDATE_ERROR";
